module.exports = __webpack_public_path__ + "static/media/30.f0f6c3fd.mp3";